import { useState } from "react";
import { makeApiRequest } from "../../utils";

const API_ENDPOINTS = {
  RUBRICS: "/api/brandRatings/brand_rating_rubrics",
  RUBRIC: (id) => `/api/brandRatings/brand_rating_rubric/${id}`,
  DUPLICATE: (id) => `/api/brandRatings/brand_rating_rubric/${id}/duplicate`
};

export function useBrandRatingRubric() {
  const [rubrics, setRubrics] = useState(null);
  const [rubric, setRubric] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRubrics = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await makeApiRequest({
        endpoint: API_ENDPOINTS.RUBRICS,
        method: "GET"
      });
      setRubrics(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const fetchRubric = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const data = await makeApiRequest({
        endpoint: API_ENDPOINTS.RUBRIC(id),
        method: "GET"
      });
      setRubric(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateRubric = async (id, data) => {
    setLoading(true);
    setError(null);

    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.RUBRIC(id),
        method: "PATCH",
        body: data,
        json: true
      });
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteRubric = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.RUBRIC(id),
        method: "DELETE"
      });
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const duplicateRubric = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DUPLICATE(id),
        method: "POST"
      });
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    rubrics,
    rubric,
    loading,
    error,
    fetchRubrics,
    fetchRubric,
    updateRubric,
    deleteRubric,
    duplicateRubric
  };
}
